import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { useSelector } from 'react-redux'
import BackgroundPageContent from 'src/components/BackgroundPageContent/BackgroundPageContent'
import Box from 'src/components/Box/Box'
import NotificationSettingsBox from 'src/components/NotificationSettingsBox/NotificationSettingsBox'
import { useBackgroundDispatch } from 'src/hooks'
import { useTranslate } from 'src/localization/Trns'
import {
  getNotificationSettings,
  patchNotificationSettings,
} from 'src/redux/actions/data/notificationSettings.actions'
import { selectUserListModelFromState } from 'src/redux/selectors/auth.selectors'
import { selectFeatureFlaggerCookiesFromState } from 'src/redux/selectors/data/featureFlagger.selectors'
import { selectNotificationSettingListModelList } from 'src/redux/selectors/data/notificationSettings.selectors'
import {
  selectAppName,
  selectEnvConfigFromState,
} from 'src/redux/selectors/session.selectors'
import { PatchNotificationSettingsRequest } from 'src/requests/patchNotificationSettings.request'
import { css } from 'styled-components'

const ProfileNotifications: React.FC = () => {
  const notificationSettings = useSelector(
    selectNotificationSettingListModelList,
  )
  const appName = useSelector(selectAppName)

  const translate = useTranslate()

  const envConfig = useSelector(selectEnvConfigFromState)
  const user = useSelector(selectUserListModelFromState)

  const showSMSSettings = useSelector(
      selectFeatureFlaggerCookiesFromState,
    )?.show_sms_settings

  const dispatch = useBackgroundDispatch()
  const dispatchGetNotificationSettings = (): void => {
    dispatch(getNotificationSettings())
  }
  const dispatchPatchNotificationSettings = (
    body: PatchNotificationSettingsRequest,
  ): void => {
    dispatch(patchNotificationSettings(body))
  }

  useEffect((): void => {
    dispatchGetNotificationSettings()
  }, [])

  return (
    <>
      <Helmet>
        <title>{`Notification Settings | ${appName}`}</title>
        <meta
          name="description"
          content={`Notification Settings page of ${appName}`}
        />
      </Helmet>
      <BackgroundPageContent>
        <NotificationSettingsBox
          notificationSettings={notificationSettings}
          patchNotifications={dispatchPatchNotificationSettings}
        />
        { showSMSSettings &&  (
          <Box
            css={css`
              display: flex;
              flex-direction: column;
              max-width: 440px;
            `}
          >
            <span
              css={css`
                display: flex;
                justify-content: space-between;
                align-items: center;
                ${getFontCss(
                  20,
                  themeConstants.colors.font_primary,
                  styleConstants.fontFamilies.medium,
                )};
              `}
            >
              {translate('SMS Notifications')}
            </span>
            <span
              css={css`
                margin-top: 30px;
              `}
            >
              {user?.smsEnabled
                ? translate(
                    'You are getting alerts via SMS. To stop receiving SMS alerts text STOP to ${phoneNumber}',
                    { phoneNumber: envConfig.TWILIO_FROM_PHONE_NUMBER || '' },
                  )
                : translate(
                    'You have opted out. Opt in by texting START to ${phoneNumber}',
                    { phoneNumber: envConfig.TWILIO_FROM_PHONE_NUMBER || '' },
                  )}
            </span>
          </Box>
        )}
      </BackgroundPageContent>
    </>
  )
}

export default ProfileNotifications
